module.exports = __webpack_public_path__ + "static/media/merged_icon_default.ced95822.svg";